import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import { bulkVisitList } from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import { handleListResponse, seo, getRecordsText } from "utils/utils";
import TableDataNotFound from "component/TableDataNotFound";
import ReactPaginate from "react-paginate";
import { newUploadStatus } from "utils/constants";
import { getConfiguration } from "reduxStore/action/masterActions";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";

const NewUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const visitorConfiguration = useSelector(
    (state) => state.visitorConfiguration
  );
  const [visitorConfigurationData, setvisitorConfigurationData] = useState([]);

  const [getbulkvisitorList, setbulkVisitorList] = useState([]);

  const { create } = usePermission({
    create: "add_new_upload",
  });

  const visitorbulkListSelector = useSelector((state) => state?.visitor);

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    search_by_name: "",
    lead_status: "",
    configuration_id: "",
  });

  useEffect(() => {
    dispatch(bulkVisitList({ limit: 10, offset: page }));
  }, [bulkVisitList]);

  useEffect(() => {
    if (visitorbulkListSelector?.response?.status === 200) {
      if (visitorbulkListSelector?.response?.data?.length > 0) {
        setbulkVisitorList(
          handleListResponse(visitorbulkListSelector?.response?.data)
            ? visitorbulkListSelector?.response?.data
            : []
        );
      }
    } else {
      setbulkVisitorList([]);
    }
  }, [visitorbulkListSelector]);

  useEffect(() => {
    if (visitorConfiguration?.response) {
      const { response } = visitorConfiguration;
      if (response?.status === 200) {
        setvisitorConfigurationData(response.data);
      } else {
        setvisitorConfigurationData([]);
      }
    }
  }, [visitorConfiguration]);

  useEffect(() => {
    dispatch(getConfiguration());
  }, []);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        bulkVisitList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          search_by_name: form.search_by_name,
          lead_status: form.lead_status,
          configuration_id: form.configuration_id,
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      search_by_name: "",
      lead_status: "",
      configuration_id: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: ""
    })
    dispatch(bulkVisitList({ limit: 10, offset: 0 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      bulkVisitList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        search_by_name: form.search_by_name,
        lead_status: form.lead_status,
        configuration_id: form.configuration_id,
      })
    );
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: ""
      })
    }
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "New Upload Listing",
      metaDescription: "New upload listing",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.newupload}
        titleactive={strings.newuploadListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByname}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchByName}
                            name="search_by_name"
                            value={form.search_by_name}
                            onChange={handleInputField}
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByConfiguration}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="configuration_id"
                            value={form.configuration_id}
                            onChange={handleInputField}
                          >
                            <option value="">
                              {strings.selectConfiguration}
                            </option>
                            {visitorConfigurationData?.length ? (
                              visitorConfigurationData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="lead_status"
                            onChange={handleInputField}
                            value={form.lead_status}
                          >
                            <option defaultValue={""}>
                              {strings.selectstatus}
                            </option>
                            <option value={1}>{strings.panding}</option>
                            <option value={2}>{strings.verify}</option>
                            <option value={3}>{strings.close}</option>
                          </select>
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning  mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listofnewupload}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.cpname}</th>
                          <th scope="col">{strings.property_name}</th>
                          <th scope="col">{strings.noOfVisitor}</th>
                          <th scope="col">{strings.noOfSiteVisit}</th>
                          <th scope="col">{strings.closingLead}</th>
                          <th scope="col">{strings.status} </th>
                          <th scope="col">{strings.images}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getbulkvisitorList?.length > 0 ? (
                          getbulkvisitorList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item?.user_name}</td>
                                <td>{item?.property_title ? item?.property_title : "-"}</td>
                                <td>{item?.total_visit}</td>
                                <td>{item?.total_site_visit}</td>
                                <td>{item?.total_closing_lead}</td>
                                <td>{newUploadStatus[item?.lead_status]}</td>
                                <td>
                                  <img
                                    src={item?.document}
                                    className="user img-fluid"
                                    alt=""
                                    type="file"
                                  />
                                </td>
                                {item?.lead_status === 1 ?
                                  <td className="p-2">
                                    {create && (
                                      <i
                                        className="fa fa-edit theme-fa-icon"
                                        aria-hidden="true"
                                        title="Create Visitor"
                                        onClick={() => {
                                          navigatpage(
                                            `/createvisitor/${item._id}`
                                          );
                                        }}
                                      ></i>
                                    )}
                                  </td> : <td className="p-2">{"-"}</td>
                                }
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getbulkvisitorList} />
                  </div>
                  <Pagination
                    totalCount={visitorbulkListSelector?.response?.total_data}
                    listData={getbulkvisitorList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewUpload;
